export default __webpack_public_path__ + "bf9d34d422dc009a6c5b235aedb1052f.png";